// bodyにheight付与
function addBodyHeight() {
	document.getElementsByTagName('body')[0].style.height = document.documentElement.clientHeight + 'px';
}
addBodyHeight();
window.onresize = addBodyHeight;
